import { render, staticRenderFns } from "./YouID.vue?vue&type=template&id=14615e44"
import script from "./YouID.vue?vue&type=script&lang=js"
export * from "./YouID.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports